module.exports = __webpack_public_path__ + "img/math.803a2cd2.png";